/* eslint-disable react/jsx-props-no-spreading */

import React from "react";
// eslint-disable-next-line react/prop-types
function AddPlusIcon({ width = 15, height = 15, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="Close/16/Icon">
        <path
          id="Vector"
          d="M16.1151 9.33987L16.1151 7.63069H9.33896L9.33896 0.854589H7.62979L7.62979 7.63069H0.853683L0.853683 9.33987L7.62979 9.33987V16.116H9.33896V9.33987L16.1151 9.33987Z"
          fill="#00ADF8"
        />
      </g>
    </svg>
  );
}
export default AddPlusIcon;
